<template>
  <v-layout class="detail" column >
    <v-flex>
      <v-card>
        <v-card-text>
          <v-layout row wrap justify-end align-center>
            <v-flex shrink pr-2>
              <span>
                Cantidad total de clientes:
              </span>
              <span>
                {{total}}
              </span>
            </v-flex>
            <v-flex shrink>
              <v-menu bottom offset-y>
                <v-btn class="mx-0" slot="activator" icon flat depressed large>
                  <v-icon>fa-cog</v-icon>
                </v-btn>
                <v-list class="pa-0">
                  <v-list-tile @click="$emit('update-segment')">
                    <v-list-tile-title>
                      Actualizar
                    </v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="$emit('variables')">
                    <v-list-tile-title>
                      Variables
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
          <vue-perfect-scrollbar class="group-scroll">
            <skeleton-box v-if="isSearching">
              <skeleton-line v-for="i in 5" :key="`line-${i}`" class="skeleton-line mt-3">
              </skeleton-line>
            </skeleton-box>
            <v-container v-else  h-100>
              <template v-if="data.length > 0">
                <v-layout card--hover @click="$emit('segment', group)" class="delimeter-group" mb-3 row wrap pt-2
                v-for="(group, i) in data" 
                :key="`group-${i}`
                ">
                  <v-flex xs12 md2 class="text-xs-center">
                    <v-layout column>
                      <v-flex>
                        <span class="title mb-1  black--text">
                          Grupo
                        </span>
                      </v-flex>
                      <v-flex>
                        <span class="headline mb-1  black--text">
                          {{ group.letter }}
                        </span>
                      </v-flex>
                      <v-flex>
                        <span class="title mb-1  black--text">
                          {{ group.percentage }}%
                        </span>
                      </v-flex>
                      <v-flex>
                        <span>
                          KPI Colektia
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md4 pr-3 mb-1>
                    <v-layout column>
                      <v-flex>
                        <span class="title">
                          Características
                        </span>
                      </v-flex>
                      <v-flex>
                        <vue-perfect-scrollbar class="feature-scroll delimeter-group pl-2">
                          <v-layout row wrap>
                            <v-flex xs12 v-for="(value, key) in group.segment_detail"
                            :key="`feature-${i}-${key}`">
                              <span 
                              :key="`feature-name-${i}-${key}`" 
                              class="caption bolder d-block">
                                {{ names[key] }}
                              </span>
                              <span v-for="(name, j) in value" 
                              :key="`feature-value-${i}-${key}-${j}`" 
                              class="pl-2 caption d-block">
                                {{ showFeatureValueName(key, name) }}
                              </span>
                            </v-flex>
                          </v-layout>
                        </vue-perfect-scrollbar>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md2 >
                    <v-layout column>
                      <v-flex mb-1>
                        <span class="title">
                          Tamaño
                        </span>
                      </v-flex>
                      <v-flex>
                        <span>
                          <span class="subheading bolder">
                            {{new Intl.NumberFormat('es-VE').format(group.quantity)}} ({{group.percentageOfGlobal}}%)
                          </span>
                          <span class="caption d-block">
                            Cuentas
                          </span>
                        </span>
                      </v-flex>
                      <v-flex>
                        <span>
                          <span class="subheading bolder">
                            ${{new Intl.NumberFormat('es-VE').format(group.dueBalance)}}
                          </span>
                          <span class="caption d-block">
                            Monto total
                          </span>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md4 >
                    <v-layout column>
                      <v-flex mb-3>
                        <span class="title">
                          Contactabilidad
                        </span>
                      </v-flex>
                      <v-flex>
                        <v-layout row wrap>
                          <v-flex xs12 md3>
                            <v-icon small class=" black--text">
                              fas fa-comments
                            </v-icon>
                            <span class="ml-2 body-2 black--text">
                              {{group.sms}} %
                            </span>
                          </v-flex>
                          <v-flex xs12 md9>
                            <v-progress-linear
                              color="green"
                              height="16"
                              style="border-radius: 0!important; margin: 1%;"
                              :value="group.sms" />
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 md3>
                            <v-icon small class=" black--text">
                              fas fa-envelope
                            </v-icon>
                            <span class="ml-2 body-2 black--text">
                              {{group.email}} %
                            </span>
                          </v-flex>
                          <v-flex xs12 md9>
                            <v-progress-linear
                              color="green"
                              height="16"
                              style="border-radius: 0!important; margin: 1%;"
                              :value="group.email" />
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 md3>
                            <v-icon small class=" black--text">
                              fas fa-phone fa-rotate-90
                            </v-icon>
                            <span class="ml-2 body-2 black--text">
                              {{group.phone}} %
                            </span>
                          </v-flex>
                          <v-flex xs12 md9>
                            <v-progress-linear
                              color="green"
                              height="16"
                              style="border-radius: 0!important; margin: 1%;"
                              :value="group.phone" />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </template>
              <template v-else>
                <v-layout row class="sizebox align-center h-100">
                  <v-flex class="text-xs-center">
                    <span class="title">
                      No hay información
                    </span>
                  </v-flex>
                </v-layout>
              </template>
            </v-container>
          </vue-perfect-scrollbar>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    total: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {
    VuePerfectScrollbar,
    SkeletonLine,
    SkeletonBox,
  },
  computed: {
    names() {
      const names = {
        gender_id: 'Genero',
        currency_id: 'Moneda',
        account_type_id: 'Producto',
        age_group_id: 'Grupo de edad',
        marital_status: 'Estado marital',
        first_delinquency: 'Primer día de mora',
        portfolio_type_id: 'Tipo de cartera',
      };
      for (let i = 0; i < this.dimentions.length; i += 1) {
        names[this.dimentions[i].field] = this.dimentions[i].title;
      }
      return names;
    },
    user() {
      return this.$auth.user();
    },
    ...mapGetters({
      dimentions: 'dimentions',
      gender_id: 'gender',
      age_group_id: 'age_group',
      currency_id: 'currency',
      account_type_id: 'account_type',
      portfolio_type_id: 'portfolio_type',
    }),
  },
  methods: {
    showFeatureValueName(key, value) {
      let name = '';
      if (key === 'marital_status') {
        if (value) {
          name = 'Casado';
        } else {
          name = 'Soltero';
        }
      } else if (key === 'first_delinquency') {
        name = value;
      } else if (key.includes('dim')) {
        const temp = this.dimentions.find(x => x.field === key);
        if (temp) {
          name = (temp.items.find(x => x.id === value) || {}).name || '';
        }
      } else if (this[key]) {
        name = this[key](value).name;
      }
      return name;
    },
  },
};
</script>
<style scoped>
.detail >>> .progress-linear__bar__determinate {
  border-radius: 0 !important;
}
.skeleton-line {
  height: 142px;
  border-radius: 0!important;
}
.group-scroll {
  height: 460px;
}
.bolder {
  font-weight: bolder;
}
.delimeter-group {
  border: 0.5px solid #c7c2c2;
  padding: 0 10px 0px 0px;
}
.feature-scroll {
  height: 88px;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/segmentation/Detail.vue